/**
 * @file ラジオボタンによる表示切り替え（移籍画面用）
 *
 */
'use strict'

import Common from "../../Utils/Common"

/**
 * @classname ChangeMemberTypeOnTransfer
 * @classdesc ラジオボタンによる表示切り替え（移籍画面用）
 */
export default class ChangeMemberTypeOnTransfer {
	/**
	 * @constructor
	 * @param {jQuery} $e - $('.change-member-type-on-transfer')
	 */
	constructor($e) {
		console.log('ChangeMemberTypeOnTransfer.constructor')
		this._$e = $e
		this._$defaultShowTarget = $(this._$e.data('default-show-target'))
		this._$radioButtons = this._$e.find('input')
		this._$radioButtons.on('change', () => this.onChange())
		this.onChange()
	}


	/**
	 * changeのコールバック
	 *
	 * @memberof ChangeMemberTypeOnTransfer
	 * @return {undefined}
	 */
	onChange() {
		console.log('ChangeMemberTypeOnTransfer.onChange')
		this._$radioButtons.each((idx, e) => Common.addIgnoreValidate($($(e).data('show-target')), false))
		$(this._$e.find('input:checked').data('show-target')).each((idx, e) => {
			$(e)
				.show()
				.find('.error-tip')
				.removeClass('show')
				.find('.error-tip-inner')
				.text('')
			$(e)
				.find('.validate')
				.removeClass('ignore-validate')
		})
		switch (this._$e.find('input:checked').attr('id')) {
			case 'member_type_1':
				$('.related-table').removeClass('col-6').addClass('col-10')
				$('.table-transferer').find('.th.toggle-required-by-member-type .badge-success').show()
				$('.table-transferer').find('.th.toggle-required-by-member-type .badge-danger').hide()
				$('.table-transferer').find('.td.toggle-required-by-member-type .validate').addClass('ignore-validate').removeClass('is-invalid')
				break
			case 'member_type_2':
				$('.related-table').removeClass('col-10').addClass('col-6')
				$('.table-transferer').find('.th.toggle-required-by-member-type .badge-success').hide()
				$('.table-transferer').find('.th.toggle-required-by-member-type .badge-danger').show()
				$('.table-transferer').find('.td.toggle-required-by-member-type .validate').removeClass('ignore-validate')
				break
			default:
				console.log('member_type value is invalid')
		}
		$('.table-transferer').closest('.form-group').find('.error-tip').removeClass('show')
	}
}
